import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import IncomeStatement from './pages/IncomeStatement';
import CashFlow from './pages/CashFlow';
import BalanceSheet from './pages/BalanceSheet';
import Trends from './pages/Trends';
import Settings from './pages/Settings';
import AccountSettings from './pages/AccountSettings';
import AdminDashboard from './pages/Admin/AdminDashboard';
import CompanyManagement from './pages/Admin/CompanyManagement';
import UserManagement from './pages/Admin/UserManagement';
import DataImport from './pages/Admin/DataImport';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import WelcomeEmail from './pages/emails/WelcomeEmail';
import FinancialReportsEmail from './pages/emails/FinancialReportsEmail';
import InvoiceEmail from './pages/emails/InvoiceEmail';
import AlertsEmail from './pages/emails/AlertsEmail';
import ProductUpdatesEmail from './pages/emails/ProductUpdatesEmail';
import FinancialTipsEmail from './pages/emails/FinancialTipsEmail';
import Landing from './pages/Landing';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/landing" element={<Landing data-id="element-3" />} data-id="element-2" />
        <Route path="/login" element={<Login data-id="element-5" />} data-id="element-4" />
        <Route path="/register" element={<Register data-id="element-7" />} data-id="element-6" />
        <Route path="/forgot-password" element={<ForgotPassword data-id="element-9" />} data-id="element-8" />
        <Route path="/emails/welcome" element={<WelcomeEmail data-id="element-11" />} data-id="element-10" />
        <Route path="/emails/financial-reports" element={<FinancialReportsEmail data-id="element-13" />} data-id="element-12" />
        <Route path="/emails/invoice" element={<InvoiceEmail data-id="element-15" />} data-id="element-14" />
        <Route path="/emails/alerts" element={<AlertsEmail data-id="element-17" />} data-id="element-16" />
        <Route path="/emails/product-updates" element={<ProductUpdatesEmail data-id="element-19" />} data-id="element-18" />
        <Route path="/emails/financial-tips" element={<FinancialTipsEmail data-id="element-21" />} data-id="element-20" />
        <Route path="/*" element={<Layout data-id="element-23">
              <Routes data-id="element-24">
                <Route path="/" element={<Dashboard data-id="element-26" />} data-id="element-25" />
                <Route path="/income-statement" element={<IncomeStatement data-id="element-28" />} data-id="element-27" />
                <Route path="/cash-flow" element={<CashFlow data-id="element-30" />} data-id="element-29" />
                <Route path="/balance-sheet" element={<BalanceSheet data-id="element-32" />} data-id="element-31" />
                <Route path="/trends" element={<Trends data-id="element-34" />} data-id="element-33" />
                <Route path="/settings" element={<Settings data-id="element-36" />} data-id="element-35" />
                <Route path="/account" element={<AccountSettings data-id="element-38" />} data-id="element-37" />
                <Route path="/admin/home" element={<AdminDashboard data-id="element-40" />} data-id="element-39" />
                <Route path="/admin/companies" element={<CompanyManagement data-id="element-42" />} data-id="element-41" />
                <Route path="/admin/users" element={<UserManagement data-id="element-44" />} data-id="element-43" />
                <Route path="/admin/data-import" element={<DataImport data-id="element-46" />} data-id="element-45" />
              </Routes>
            </Layout>} data-id="element-22" />
      </Routes>
    </BrowserRouter>;
}